import { watch } from "vue";
import { createGlobalState } from "@vueuse/core";

import useAuthState from "@/composables/state/authState";
import analyticsProviders from "@/lib/analytics/providers";
import { AnalyticsService } from "@/lib/analytics/AnalyticsService";

export const useAnalyticsState = createGlobalState(() => {
  const analyticsService = new AnalyticsService([
    new analyticsProviders.FullStoryAnalyticsProvider(),
    new analyticsProviders.PostHogAnalyticsProvider(),
  ]);

  const { loggedInUser } = useAuthState();

  watch(loggedInUser, (value) => {
    const payload = value ? { id: value.id, email: value.email } : null;
    analyticsService.trackUserChange(payload);
  });

  return { trackEvent: analyticsService.trackEvent.bind(analyticsService) };
});
